module.exports = __webpack_public_path__ + "static/media/maker.ac5206ae.svg";